import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

const navLinks = [
  { path: '/', label: '首页' },
  {
    path: '#',
    label: '分类',
    children: [
      { path: '/category/bladder-health', label: '膀胱健康' },
      { path: '/category/training-methods', label: '训练方法' },
      { path: '/category/diet-nutrition', label: '饮食调理' },
      { path: '/category/daily-care', label: '日常保健' },
    ],
  },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors duration-200"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-mental-health-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl font-semibold tracking-tight whitespace-nowrap">
                膀胱健康知识网
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) =>
                link.children ? (
                  <div
                    key={link.label}
                    className="relative"
                    onMouseEnter={() => setDropdownOpen(true)}
                    onMouseLeave={() => setDropdownOpen(false)}
                  >
                    <button
                      className={`flex items-center gap-1 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                        location.pathname.startsWith('/category')
                          ? 'text-primary-500'
                          : 'text-foreground-700 hover:text-primary-500'
                      }`}
                    >
                      {link.label}
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i
                          className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${
                            dropdownOpen ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </div>
                    </button>
                    {dropdownOpen && (
                      <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-background-50 rounded-lg shadow-md border border-background-200/70 py-2 min-w-[180px]">
                        {link.children.map((child) => (
                          <Link
                            key={child.path}
                            to={child.path}
                            className={`block px-4 py-2.5 text-sm transition-colors duration-150 whitespace-nowrap ${
                              location.pathname === child.path
                                ? 'text-primary-500 bg-primary-50'
                                : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                            }`}
                          >
                            {child.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                      location.pathname === link.path
                        ? 'text-primary-500'
                        : 'text-foreground-700 hover:text-primary-500'
                    }`}
                  >
                    {link.label}
                  </Link>
                )
              )}
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer text-foreground-700 hover:text-primary-500 transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70">
            <div className="px-4 py-3 flex flex-col gap-1">
              {navLinks.map((link) =>
                link.children ? (
                  <div key={link.label}>
                    <p className="px-3 py-2 text-sm font-medium text-foreground-500">
                      {link.label}
                    </p>
                    {link.children.map((child) => (
                      <Link
                        key={child.path}
                        to={child.path}
                        className={`block px-6 py-2.5 text-sm rounded-md transition-colors ${
                          location.pathname === child.path
                            ? 'text-primary-500 bg-primary-50'
                            : 'text-foreground-700 hover:bg-background-100 hover:text-primary-500'
                        }`}
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                ) : (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`px-3 py-2.5 text-sm font-medium rounded-md transition-colors ${
                      location.pathname === link.path
                        ? 'text-primary-500 bg-primary-50'
                        : 'text-foreground-700 hover:bg-background-100 hover:text-primary-500'
                    }`}
                  >
                    {link.label}
                  </Link>
                )
              )}
            </div>
          </div>
        )}
      </nav>
      <div className="h-16"></div>
    </>
  );
}